export default __webpack_public_path__ + "media/zurb/img/ecommerce/tmw_comp_1-6ca02a2a16ff168556ba60cd6ed7f8f7.png";